import { mediaItems } from '@/mocks/home';

export default function SectionMedia() {
  return (
    <section id="media" className="py-10 md:py-14 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-6">
          <i className="ri-play-circle-line text-primary-500 mr-2"></i>
          精彩影评
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {mediaItems.map((item) => (
            <article
              key={item.title}
              className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/70 transition-all duration-300 cursor-pointer hover:border-primary-200"
            >
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.cover}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  onError={(e) => {
                    (e.currentTarget.parentElement as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-background-950/30 flex items-center justify-center">
                  <span className="w-12 h-12 flex items-center justify-center bg-background-50/90 rounded-full transition-transform duration-300 group-hover:scale-110">
                    <i className="ri-play-fill text-xl text-primary-600 ml-0.5"></i>
                  </span>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 bg-background-950/70 text-background-50 text-xs rounded whitespace-nowrap">
                  {item.duration}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors duration-200">
                  {item.title}
                </h3>
                <div className="flex items-center gap-1 text-xs text-secondary-500">
                  <i className="ri-eye-line"></i>
                  <span>{item.views} 次观看</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}